(function() {
    'use strict';

    angular
        .module('atheer.services')
        .factory('AuditsService', AuditsService);

    /* @ngInject */
    function AuditsService($resource) {
        var service = $resource('api/system/audits/:id', {}, {
            'get': {
                method: 'GET',
                isArray: true
            },
            'query': {
                method: 'GET',
                isArray: true,
                params: {
                    fromDate: null,
                    toDate: null
                }
            }
        });

        return service;
    }
})();
